module.exports = window["SSCIconsReact"];